import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "banner-image-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "heading d1 banner-title text-white"
}


import { NIcon } from 'naive-ui';
import { ChevronLeftRound } from '@vicons/material'
import { getImgUrl } from '@/ts/helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'SideBanner',
  props: {
  backRouteName: String,
  bannerImg: String,
  bannerText: String
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.backRouteName)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          class: "simple-link style-normal flex-center",
          to: { name: __props.backRouteName }
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NIcon), null, {
              default: _withCtx(() => [
                _createVNode(_unref(ChevronLeftRound))
              ]),
              _: 1
            }),
            _createTextVNode(" Back ")
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (__props.bannerImg)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "banner-img",
            src: _unref(getImgUrl)(props.bannerImg)
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (__props.bannerText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.bannerText), 1))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "short-description")
  ]))
}
}

})